import { useState, useEffect, useRef } from "react";
import { hasContentProp } from "../../../refractCommon/miro/hasProp";
const miro = window.miro;

export default function Lorem() {
  const [paraSliderValue, setParaSliderValue] = useState(0);
  const [sentenceSliderValue, setSentenceSliderValue] = useState(0);
  const [wordSliderValue, setWordSliderValue] = useState(0);
  const [loremOutput, setLoremOutput] = useState("");
  const [warning, setWarning] = useState("");
  const [toolOpen, setToolOpen] = useState(false);
  const [setHeight, setHeightState] = useState("0px");

  const content = useRef<HTMLInputElement>(null);

  function handleToggleOpen() {
    setToolOpen(!toolOpen);
    setHeightState(toolOpen ? "0px" : `${content?.current?.scrollHeight}px`);
  }

  const loremItemTypeIcons = (
    <div className="cs5 ce12 grid">
      <div className="m2 icon icon-rectangle cs1"></div>
      <div className="m2 icon icon-sticky-bulk cs2"></div>
      <div className="m2 icon icon-text cs3"></div>
    </div>
  );

  async function getSelection() {
    const miroSelection = await miro.board.getSelection();
    const item = miroSelection[0];

    if (miroSelection.length === 0) {
      setWarning("Please select an item on the board.");
      return;
    }

    if (miroSelection.length > 1) {
      setWarning("Please select only one item on the board.");
      return;
    }

    if (hasContentProp(item)) {
      item.content = loremOutput;
      item.sync();
      if (warning !== "") {
        setWarning("");
      }
    } else {
      setWarning("Please select either a text, sticky note, or shape item.");
      return;
    }
  }

  function updateSlider(e: any, flag: string) {
    let value = e.target.value;
    var counts: {
      para: number;
      sentence: number;
      word: number;
      [key: string]: number;
    } = { para: 0, sentence: 0, word: 0 };
    counts[flag] = value;
    setLoremOutput(getLorem(value, flag));
    setParaSliderValue(counts.para);
    setSentenceSliderValue(counts.sentence);
    setWordSliderValue(counts.word);
  }

  function getLorem(value: number, flag: string) {
    if (flag === "para") {
      return (
        "<p class='p-small'>" +
        loremSourceText
          .split("\n")
          .splice(0, value)
          .join("</p class='p-small'><p>") +
        "</p>"
      );
    } else if (flag === "sentence") {
      return (
        "<p class='p-small'>" +
        loremSourceText.split(".").splice(0, value).join(".") +
        "</p>"
      );
    } else if (flag === "word") {
      return (
        "<p class='p-small'>" +
        loremSourceText
          .replaceAll(/\s+/g, " ")
          .split(" ")
          .splice(0, value)
          .join(" ") +
        "</p>"
      );
    }
    return "";
  }

  return (
    <div id="lorem-tool" className="grid tool-section mt-0 pb-0">
      <div
        id="lorem-tool-header"
        className={"grid cs1 ce12 mt-0 cursor-pointer"}
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <div className="cs1 mb-0 icon m2 icon-align-left"></div>
        <div className="cs2 ce11 h3 mb-0">Lorem Ipsum</div>
        <div
          className={
            "cs12 icon m2 mb-0 mt-0 cursor-pointer" +
            " " +
            (toolOpen === false ? " icon-arrow-right" : " icon-arrow-down")
          }></div>
      </div>
      <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="cs1 ce12 grid accordion">
        <div id="accordion-margin" className="cs1 ce12 grid mb-8">
          <div
            id="lorem-works-on"
            className="help-container grid cs1 ce12 mt-0 mb-8 pt-8">
            <p className="p-small cs1 ce4 mb-0 mt-0">
              Works on <b>1:</b>
            </p>
            {loremItemTypeIcons}
          </div>
          {/*  */}
          <div className="grid cs1 mt-0 ce12">
            <div className="grid cs1 mt-0 ce4">
              <div className="cs1 ce12 mt-0 mb-0">
                <p className="p-medium mb-0 mt-0 pb-0">
                  <b>{wordSliderValue}</b> Words
                </p>
                <p className="cs7 p-medium mb-0 mt--6"></p>
              </div>
              <div className="slidecontainer mb-0 mt--6">
                <input
                  type="range"
                  min="0"
                  max="15"
                  value={wordSliderValue}
                  className="slider"
                  onChange={(e) => {
                    updateSlider(e, "word");
                  }}
                  // onMouseUp={() => {}}
                  id="myParaRange"
                />
              </div>

              <div className="cs1 ce12 mb-0">
                <p className="p-medium mb-0 mt-0 pb-0">
                  <b>{sentenceSliderValue}</b> Sentences
                </p>
                <p className="cs7 p-medium mb-0 mt--6"></p>
              </div>

              <div className="slidecontainer mb-0 mt--6">
                <input
                  type="range"
                  min="0"
                  max="10"
                  value={sentenceSliderValue}
                  className="slider"
                  onChange={(e) => {
                    updateSlider(e, "sentence");
                  }}
                  // onMouseUp={() => {}}
                  id="myParaRange"
                />
              </div>

              <div className="cs1 ce12 mb-0">
                <p className="p-medium mb-0 mt-0 pb-0">
                  <b>{paraSliderValue}</b> Paragraphs
                </p>
                <p className="cs7 p-medium mb-0 mt--6"></p>
              </div>
              <div className="slidecontainer mb-8 mt--6">
                <input
                  type="range"
                  min="0"
                  max="5"
                  value={paraSliderValue}
                  className="slider"
                  onChange={(e) => {
                    updateSlider(e, "para");
                  }}
                  // onMouseUp={() => {}}
                  id="myParaRange"
                />
              </div>
            </div>
            <div id="lorem-preview" className="cs5 ce12">
              <div
                style={{
                  color: "var(--indigo400)",
                  display: loremOutput === "" ? "block" : "none",
                }}
                className="p-small align-center">
                preview
              </div>
              <div dangerouslySetInnerHTML={{ __html: loremOutput }}></div>
            </div>
          </div>

          <div className="grid cs1 ce12">
            <button
              disabled={loremOutput === ""}
              type="button"
              className="button button-primary button-small cs1 ce12 mt-16"
              onClick={getSelection}>
              Write Lorem into Board Item
            </button>
            {/* {warning.length > 0 && (
            <div className="cs1 ce12 label label-warning">{warning}</div>
          )} */}
          </div>
        </div>
      </div>
    </div>
  );
}

const loremSourceText = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam non augue quis enim lobortis ultrices. Aenean tempor mollis massa eget fringilla. Duis cursus elit eget pretium dignissim. Nunc euismod nibh id fringilla iaculis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi eu velit sollicitudin, finibus lorem ac, dictum sem. Maecenas sed nulla erat. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Morbi consequat sit amet odio sed eleifend. Fusce a lobortis dui, vitae consectetur nibh. Suspendisse vel vulputate nisi, et finibus tortor. Proin at leo a diam gravida egestas.
Ut finibus interdum augue id tristique. Aenean ut tellus eros. Aliquam pretium erat in tellus vehicula, et ultrices mi interdum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec risus hendrerit, pretium est gravida, pharetra leo. Pellentesque ut semper dui, quis porta neque. Nunc ut volutpat dolor. Curabitur nec ex ut arcu vestibulum semper. In malesuada tincidunt ullamcorper. Maecenas scelerisque, libero a euismod aliquet, nisl libero interdum ipsum, ac placerat quam libero sed ligula.
Suspendisse potenti. Fusce laoreet, tellus id malesuada iaculis, libero nunc elementum nisl, bibendum ultricies felis arcu sit amet nulla. Aenean in risus lacinia, pellentesque nibh ut, pharetra metus. Vivamus cursus libero vitae scelerisque varius. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Suspendisse ac neque eget diam aliquet tincidunt ut eget mauris. Curabitur suscipit lobortis turpis vitae pulvinar. Aliquam fermentum at urna imperdiet lacinia. Nulla facilisi. Quisque lectus nulla, sollicitudin ac pellentesque quis, sodales ut urna. Vivamus sit amet ante velit.
Donec interdum varius aliquet. Vestibulum eleifend sem vitae viverra euismod. Curabitur sit amet odio non orci ultrices efficitur quis ut massa. Fusce congue mauris non justo rhoncus, sit amet imperdiet elit maximus. Praesent feugiat vulputate urna ac dignissim. Etiam eleifend pretium tellus eget lacinia. Pellentesque ultrices erat at elit efficitur, maximus pharetra urna consectetur.
Vestibulum volutpat ante a arcu ultricies lacinia. Aliquam scelerisque pulvinar nisi in elementum. Donec cursus nisl sed lacus hendrerit rhoncus. Etiam consectetur nibh consectetur, sagittis odio vitae, blandit felis. Etiam vulputate massa velit, sit amet finibus orci hendrerit sit amet. Cras nec bibendum eros. Suspendisse elementum, orci quis feugiat pharetra, nisl quam maximus sem, at lacinia ex odio id purus.`;
